// extracted by mini-css-extract-plugin
export default {"checkbox":"_1HsVq","align-items-center":"_1Kgr5","alignItemsCenter":"_1Kgr5","label":"Fg1n3"};